// import React, { useState, useEffect } from "react"
// import { Trophy, Lock, CheckCircle, Clock, Gift, Star } from "lucide-react"
// import { fetchUserRewards } from "../redux/rewardSlice"
// import { useSelector, useDispatch } from "react-redux"

// const CountdownTimer = ({ endDate }) => {
//   const [timeLeft, setTimeLeft] = useState({
//     days: 0,
//     hours: 0,
//     minutes: 0,
//     seconds: 0,
//   })

//   useEffect(() => {
//     const calculateTimeLeft = () => {
//       const difference = new Date(endDate) - new Date()

//       if (difference > 0) {
//         const days = Math.floor(difference / (1000 * 60 * 60 * 24))
//         const hours = Math.floor((difference / (1000 * 60 * 60)) % 24)
//         const minutes = Math.floor((difference / 1000 / 60) % 60)
//         const seconds = Math.floor((difference / 1000) % 60)

//         return { days, hours, minutes, seconds }
//       }

//       return { days: 0, hours: 0, minutes: 0, seconds: 0 }
//     }

//     const timer = setInterval(() => {
//       setTimeLeft(calculateTimeLeft())
//     }, 1000)

//     return () => clearInterval(timer)
//   }, [endDate])

//   return (
//     <div className="flex items-center space-x-1 text-sm font-medium text-indigo-600 bg-indigo-50 px-3 py-1 rounded-full">
//       <Clock className="w-4 h-4 mr-1" />
//       <span>{timeLeft.days}d </span>
//       <span>{timeLeft.hours}h </span>
//       <span>{timeLeft.minutes}m </span>
//       <span>{timeLeft.seconds}s</span>
//     </div>
//   )
// }

// const RewardLevelCard = ({
//   level,
//   rewardAmount,
//   isCompleted,
//   startDate,
//   endDate,
//   currentBusiness,
//   threshold,
//   isActive,
//   title,
// }) => {
//   return (
//     <div
//       className={`relative p-5 border rounded-xl shadow-sm transition-all duration-300 ${
//         isCompleted
//           ? "bg-gradient-to-br from-green-50 to-green-100 border-green-200"
//           : startDate
//             ? "bg-gradient-to-br from-white to-blue-50 border-blue-200"
//             : "bg-gradient-to-br from-gray-50 to-gray-100 border-gray-200"
//       } ${isActive ? "animate-pulse shadow-md" : ""} hover:shadow-md`}
//     >
//       {isActive && (
//         <div className="absolute -top-2 -right-2 bg-yellow-400 text-yellow-900 text-xs font-bold px-2 py-1 rounded-full shadow-md">
//           ACTIVE
//         </div>
//       )}

//       <div className="flex items-center space-x-5">
//         <div className="relative">
//           <div
//             className={`w-16 h-16 rounded-full flex items-center justify-center ${
//               isCompleted
//                 ? "bg-green-100 text-green-600"
//                 : startDate
//                   ? "bg-blue-100 text-blue-600"
//                   : "bg-gray-100 text-gray-400"
//             }`}
//           >
//             {isCompleted ? (
//               <CheckCircle className="w-8 h-8" />
//             ) : startDate ? (
//               <Trophy className="w-8 h-8" />
//             ) : (
//               <Lock className="w-8 h-8" />
//             )}
//           </div>
//         </div>

//         <div className="flex-1">
//           <div className="flex justify-between items-center mb-2">
//             <div>
//               <div className="flex items-center">
//                 {/* <span className="bg-indigo-100 text-indigo-800 text-xs font-medium px-2.5 py-0.5 rounded-full mr-2">
//                   Level {level}
//                 </span> */}
//                 <h3 className="text-lg font-bold text-gray-800">{title}</h3>
//               </div>
//             </div>
//             {isCompleted && <Trophy className="text-yellow-500 w-6 h-6" />}
//           </div>

//           <div className="flex items-center mb-3">
//             <Gift className="w-4 h-4 text-emerald-500 mr-1" />
//             <p className="text-sm font-semibold text-emerald-600">Reward: ${rewardAmount}</p>
//           </div>

//           {startDate && (
//             <div className="flex flex-wrap gap-2 items-center">
//               {threshold && (
//                 <div className="flex items-center bg-blue-50 px-3 py-1 rounded-full">
//                   <Star className="w-4 h-4 text-blue-600 mr-1" />
//                   <span className="text-sm font-medium text-blue-700">
//                     Goal: {currentBusiness} / {threshold}
//                   </span>
//                 </div>
//               )}

//               {endDate && <CountdownTimer endDate={endDate} />}
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   )
// }

// const UserRewardsComponent = ({ rewards }) => {
//   return (
//     <div className="max-w-2xl mx-auto p-8 bg-white rounded-2xl shadow-lg">
//       <div className="flex items-center mb-8 pb-4 border-b border-gray-100">
//         <div className="bg-yellow-100 p-3 rounded-full mr-4">
//           <Trophy className="w-10 h-10 text-yellow-600" />
//         </div>
//         <div className="flex-1">
//           <h2 className="text-2xl font-bold text-gray-800 mb-1">Starter Plan Rewards</h2>
//           <p className="text-gray-500">Complete challenges to earn rewards</p>
//         </div>
//       </div>

//       <div className="space-y-5">
//         {rewards.map((reward) => (
//           <RewardLevelCard
//             key={reward.id}
//             level={reward.level}
//             title={reward.title}
//             rewardAmount={reward.reward_amount}
//             isCompleted={reward.is_completed === 1}
//             startDate={reward.start_date}
//             endDate={reward.end_date}
//             currentBusiness={reward.current_business}
//             threshold={reward.threshold}
//             isActive={reward.is_active == 1}
//           />
//         ))}
//       </div>

//       <div className="mt-8 p-5 bg-indigo-50 border border-indigo-100 rounded-xl">
//         <div className="flex items-start">
//           <div className="bg-indigo-100 p-2 rounded-full mr-3">
//             <Gift className="w-6 h-6 text-indigo-600" />
//           </div>
//           <div>
//             <h3 className="font-bold text-indigo-800 mb-1">Complete Your Journey</h3>
//             <p className="text-sm text-indigo-700">
//               🏆 Finish all levels to unlock the full Starter Plan reward package!
//             </p>
//           </div>
//         </div>
//       </div>
//     </div>
//   )
// }

// export default function RewardsPage() {
//   const dispatch = useDispatch()
//   const { auth } = useSelector((state) => state.auth)
//   const { rewards, loading } = useSelector((state) => state.rewards)

//   React.useEffect(() => {
//     if (auth) {
//       dispatch(fetchUserRewards(auth?.id))
//     }
//   }, [dispatch, auth])

//   if (loading) {
//     return (
//       <div className="flex justify-center items-center h-full">
//         <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-indigo-500"></div>
//       </div>
//     )
//   }

//   return <UserRewardsComponent rewards={rewards} />
// }

import React, { useState, useEffect } from "react";
import {
  Trophy,
  Lock,
  CheckCircle,
  Clock,
  Gift,
  Star,
  Award,
  ChevronRight,
  // Loader,
} from "lucide-react";
import Loader from "../BaseFile/comman/Loader";
import { fetchUserRewards } from "../redux/rewardSlice";
import { useSelector, useDispatch } from "react-redux";

const CountdownTimer = ({ endDate }) => {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  useEffect(() => {
    const calculateTimeLeft = () => {
      const difference = new Date(endDate) - new Date();

      if (difference > 0) {
        const days = Math.floor(difference / (1000 * 60 * 60 * 24));
        const hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
        const minutes = Math.floor((difference / 1000 / 60) % 60);
        const seconds = Math.floor((difference / 1000) % 60);

        return { days, hours, minutes, seconds };
      }

      return { days: 0, hours: 0, minutes: 0, seconds: 0 };
    };

    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timer);
  }, [endDate]);

  return (
    <div className="flex items-center space-x-1 text-sm font-medium text-indigo-700 bg-indigo-50 px-3 py-1.5 rounded-full shadow-sm">
      <Clock className="w-4 h-4 text-indigo-500" />
      <div className="flex items-center space-x-1">
        <span className="font-bold">{timeLeft.days}</span>
        <span className="text-indigo-500 text-xs">d</span>
      </div>
      <div className="flex items-center space-x-1">
        <span className="font-bold">{timeLeft.hours}</span>
        <span className="text-indigo-500 text-xs">h</span>
      </div>
      <div className="flex items-center space-x-1">
        <span className="font-bold">{timeLeft.minutes}</span>
        <span className="text-indigo-500 text-xs">m</span>
      </div>
      <div className="flex items-center space-x-1">
        <span className="font-bold">{timeLeft.seconds}</span>
        <span className="text-indigo-500 text-xs">s</span>
      </div>
    </div>
  );
};

const RewardLevelCard = ({
  level,
  rewardAmount,
  isCompleted,
  startDate,
  endDate,
  currentBusiness,
  threshold,
  isActive,
  title,
}) => {
  const cardTheme = {
    completed: {
      container:
        "bg-gradient-to-br from-green-50 to-green-100 border-green-200",
      iconBg: "bg-green-500 text-white",
      statusBadge: "bg-green-100 text-green-700 border-green-200",
      progressBg: "bg-green-200",
      progressFill: "bg-green-500",
    },
    active: {
      container: "bg-gradient-to-br from-blue-100 to-blue-200 border-blue-200",
      iconBg: "bg-blue-500 text-white",
      statusBadge: "bg-blue-100 text-blue-700 border-blue-200",
      progressBg: "bg-blue-200",
      progressFill: "bg-blue-500",
    },
    locked: {
      container: "bg-gradient-to-br from-gray-100 to-gray-200 border-gray-200",
      iconBg: "bg-gray-400 text-white",
      statusBadge: "bg-gray-100 text-gray-700 border-gray-200",
      progressBg: "bg-gray-200",
      progressFill: "bg-gray-400",
    },
  };
  const cardStatus = isCompleted
    ? "completed"
    : startDate
    ? "active"
    : "locked";
  const theme = cardTheme[cardStatus];
  const progress =
    startDate && threshold
      ? Math.min(100, (currentBusiness / threshold) * 100)
      : 0;

  return (
    <div
      className={`relative p-6 border-2 rounded-2xl shadow transition-all duration-300 ${
        theme.container
      } ${
        isActive ? "ring-2 ring-yellow-300 shadow-lg" : ""
      } hover:shadow-md group`}
    >
      {isActive && (
        <div className="absolute -top-3 -right-1 bg-gradient-to-r from-yellow-400 to-amber-500 text-white text-xs font-bold px-3 py-1 rounded-full shadow">
          ACTIVE
        </div>
      )}

      <div className="sm:flex items-start sm:space-x-4">
        <div
          className={`sm:rounded-2xl rounded-md mb-4 sm:mb-0 flex justify-center  w-16 p-3 ${theme.iconBg} shadow-md transform group-hover:scale-105 transition-transform`}
        >
          {isCompleted ? (
            <CheckCircle className="w-8 h-8" />
          ) : startDate ? (
            <Trophy className="w-8 h-8" />
          ) : (
            <Lock className="w-8 h-8" />
          )}
        </div>

        <div className="flex-1">
          <div className="flex justify-between items-center mb-2">
            <div>
              <h3 className="text-lg font-bold text-gray-800 flex items-center">
                {title}
                {cardStatus === "completed" && (
                  <Trophy className="ml-2 text-yellow-500 w-5 h-5" />
                )}
              </h3>
              <div className="text-xs uppercase tracking-wider font-semibold text-gray-500 mt-1">
                Level {level}
              </div>
            </div>

            {cardStatus === "completed" && (
              <div className="bg-green-100 p-1.5 rounded-full">
                <CheckCircle className="text-green-600 w-5 h-5" />
              </div>
            )}
          </div>

          <div className="flex items-center mt-2 mb-3">
            <div className="flex items-center space-x-2 px-3 py-1.5 bg-emerald-50 rounded-full shadow-sm">
              <Gift className="w-4 h-4 text-emerald-500" />
              <p className="text-sm font-bold text-emerald-600">
                ${rewardAmount}
              </p>
            </div>
          </div>
          {threshold && (
            <div className="mt-3 mb-2">
              <div className="flex justify-between text-xs font-medium mb-1">
                <span
                  className={
                    cardStatus === "completed"
                      ? "text-green-700"
                      : "text-gray-600"
                  }
                >
                  Progress
                </span>
                <span className="font-bold text-black">
                  {currentBusiness}/{threshold}
                </span>
              </div>
              <div
                className={`w-full h-2 ${theme.progressBg} rounded-full overflow-hidden`}
              >
                <div
                  className={`h-full ${theme.progressFill} transition-all duration-500`}
                  style={{ width: `${progress}%` }}
                ></div>
              </div>
            </div>
          )}

          <div className="flex flex-wrap gap-2 items-center mt-3">
            {cardStatus === "completed" ? (
              <div
                className={`flex items-center text-sm font-medium ${theme.statusBadge} border px-3 py-1 rounded-full`}
              >
                <Award className="w-4 h-4 mr-1" />
                Completed
              </div>
            ) : cardStatus === "active" ? (
              <>{endDate && <CountdownTimer endDate={endDate} />}</>
            ) : (
              <div className="flex items-center text-sm font-medium bg-gray-100 text-gray-500 px-3 py-1 rounded-full">
                <Lock className="w-4 h-4 mr-1" />
                Locked
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
const UserRewardsComponent = ({ rewards }) => {
  const completedCount = rewards.filter((r) => r.is_completed === 1).length;
  const totalRewards = rewards.reduce(
    (sum, reward) => sum + Number(reward.reward_amount),
    0
  );
  const earnedRewards = rewards
    .filter((r) => r.is_completed === 1)
    .reduce((sum, reward) => sum + Number(reward.reward_amount), 0);

  return (
    <div className="max-w-7xl mx-auto p-5 bg-[#fff] rounded-md shadow-sm border border-gray-300">
      <div className="flex flex-col lg:flex-row lg:items-center justify-between mb-8 pb-6 border-b border-gray-100">
        <div className="flex items-center mb-4 lg:mb-0">
          <div className="bg-gradient-to-br from-amber-400 to-yellow-500 p-3 rounded-xl mr-4 shadow-md">
            <Trophy className="w-10 h-10 text-white" />
          </div>
          <div>
            <h2 className="text-2xl font-bold text-gray-800 mb-1">
              Starter Plan Rewards
            </h2>
            <p className="text-gray-500">Complete challenges to earn rewards</p>
          </div>
        </div>

        <div className="flex items-center justify-between gap-4 sm:gap-4  bg-gradient-to-r from-indigo-100 to-white backdrop-blur-md p-2 rounded-md shadow-sm border border-indigo-200 transition-all duration-300 hover:shadow-xl">
          <div className="flex-1 text-center bg-white/60 backdrop-blur-sm p-4 rounded-md border border-gray-300 shadow-inner hover:scale-105 transform transition duration-300 ease-in-out">
            <div className="text-xs sm:text-sm font-semibold text-indigo-600 tracking-wide uppercase">
              Completed
            </div>
            <div className="text-base font-semibold text-indigo-800 mt-1">
              {completedCount}/{rewards.length}
            </div>
          </div>
          <div className="flex-1 text-center bg-white/60 backdrop-blur-sm p-4 border border-gray-300 rounded-md shadow-inner hover:scale-105 transform transition duration-300 ease-in-out">
            <div className="text-xs sm:text-sm font-semibold text-indigo-600 tracking-wide uppercase">
              Earned
            </div>
            <div className="text-base font-semibold text-indigo-800 mt-1">
              ${earnedRewards}/${totalRewards}
            </div>
          </div>
        </div>
      </div>

      <div className="space-y-6">
        {rewards.map((reward) => (
          <RewardLevelCard
            key={reward.id}
            level={reward.level}
            title={reward.title}
            rewardAmount={reward.reward_amount}
            isCompleted={reward.is_completed === 1}
            startDate={reward.start_date}
            endDate={reward.end_date}
            currentBusiness={reward.current_business}
            threshold={reward.threshold}
            isActive={reward.is_active == 1}
          />
        ))}
      </div>

      <div className="mt-8 p-5 bg-gradient-to-r from-indigo-50 to-blue-50 border border-indigo-100 rounded-xl shadow-sm hover:shadow-md transition-shadow">
        <div className="sm:flex sm:items-start">
          <div className="bg-gradient-to-br w-16  flex justify-center from-indigo-500 to-indigo-600 p-3 rounded-md sm:rounded-xl shadow-md sm:mr-4">
            <Gift className="w-6 h-6 text-white" />
          </div>
          <div className="flex-1">
            <h3 className="font-bold text-indigo-800 mb-1 text-lg">
              Complete Your Journey
            </h3>
            <p className="text-indigo-600">
              Finish all levels to unlock the full Starter Plan reward package!
            </p>
            <div className="mt-3 flex items-center text-indigo-700 font-medium text-sm">
              <span>View all rewards</span>
              <ChevronRight className="w-4 h-4 ml-1" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default function RewardsPage() {
  const dispatch = useDispatch();
  const { auth } = useSelector((state) => state.auth);
  const { rewards, loading } = useSelector((state) => state.rewards);

  React.useEffect(() => {
    if (auth) {
      dispatch(fetchUserRewards(auth?.id));
    }
  }, [dispatch, auth]);

  if (loading) {
    return (
      <>
      <Loader isLoading={loading} />
      </>
    );
  }

  return <UserRewardsComponent rewards={rewards} />;
}
